import { z } from 'zod';

export const apiSchema = z
  .object({
    VITE_BACKEND_ENDPOINT: z.string().optional(),
    /** xvia-xroad-mock-api — a "base do DETRAN" que esta tela edita. */
    VITE_DETRAN_MOCK_ENDPOINT: z.string().default('http://localhost:8090'),
  })
  .transform((env) => ({
    api: {
      backendEndpoint: env.VITE_BACKEND_ENDPOINT,
      detranMockEndpoint: env.VITE_DETRAN_MOCK_ENDPOINT,
    },
  }));
